import { BRAND_FEATURED } from "../../actions/type";

export default function brandFeature(state = [], action) {
    switch (action.type) {
        case BRAND_FEATURED:
            return action.payload;;
        default:
            return state
    }
}